import { CtaType } from "../../../types/Cta";
import { post } from "../../../utils/axios-config";
import { CTAS } from "../../../utils/constants";

export const createCta = async (data: CtaType) => await post<CtaType, string>(CTAS, data);